<template>
  <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row justify-content-between">
            <div class="col-auto">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Profile</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->
              <!-- {{this.profileArr}} -->
            </div>
            <div class="col-auto">
              <select
                class="form-control"
                v-model="insightparams.percent_view"
                @change="loadInsightProfile"
              >
                <option value="7daysago">7 days ago</option>
                <option value="30daysago">30 days ago</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card-group m-b-30">
                <skeleton height="180px" width="150px" v-if="isLoading" />
                <template v-else>
                  <div
                    class="card"
                    v-for="(row, idx) in rows_insight"
                    :key="idx"
                  >
                    <div class="card-body">
                      <div class="d-flex justify-content-between mb-3">
                        <div>
                          <span class="d-block">
                            <span v-html="renameLabel(idx)"></span>
                          </span>
                        </div>
                        <div></div>
                      </div>
                      <div v-if="loading_persen" class="mb-3">
                        <skeleton height="1.5rem" />
                      </div>
                      <template v-else>
                        <h3 class="mb-3">{{ row.now | angkaKMB }}</h3>
                      </template>
                      <div class="progress mb-2" style="height: 5px;">
                        <div
                          class="progress-bar bg-primary"
                          role="progressbar"
                          style="width: 100%;"
                          aria-valuenow="40"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <p class="mb-0">
                        <skeleton height="40px" v-if="loading_persen" />
                        <template v-else>
                          <!-- <span class="text-success"
                            >+{{ rows_percent[idx] }}</span
                          > -->
                          <span
                            :class="[
                              rows_percent[idx] > 0
                                ? 'text-success'
                                : rows_percent[idx] == 0
                                ? 'text-secondary'
                                : 'text-danger'
                            ]"
                            >{{ rows_percent[idx] > 0 ? "+" : ""
                            }}{{ rows_percent[idx] }}%</span
                          >
                          <span
                            class="text-muted"
                            v-if="insightparams.percent_view === '7daysago'"
                            >in the last 7 days</span
                          >
                          <span
                            class="text-muted"
                            v-if="insightparams.percent_view === '30daysago'"
                            >in the last 30 days</span
                          >
                        </template>
                      </p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card v-graph">
                <div class="card-body">
                  <h3 class="card-title">New Followers</h3>
                  <!-- <div id="line-chart" style="width:auto !important"></div> -->
                  <line-chart 
                    id="line" 
                    :data="lineData" 
                    xkey= "y"
                    ykeys= '["a"]'
                    labels= '["Follower"]'
                    resize="true">
                  </line-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "./sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import { LineChart } from "vue-morris";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    LineChart
  },
  filters: {
    angkaKMB(value) {
      if (value >= 1e9)
        return (
          ((value / 1e9) % 1 === 0 ? value / 1e9 : (value / 1e9).toFixed(2)) +
          "B"
        );
      if (value >= 1e6)
        return (
          ((value / 1e6) % 1 === 0 ? value / 1e6 : (value / 1e6).toFixed(2)) +
          "M"
        );
      if (value >= 1e3)
        return (
          ((value / 1e3) % 1 === 0 ? value / 1e3 : (value / 1e3).toFixed(2)) +
          "K"
        );
      return value;
    }
  },
  data() {
    return {
      isLoading: true,
      loading_persen: true,
      profileArr: {
        email: "",
        name: "",
        phone: ""
      },
      rows_insight: [],
      rows_percent: [],
      insightparams: {
        instagram_id: this.$route.query.instagram_id,
        percent_view: "7daysago"
      },
      lineData: [],
    };
  },
  created() {
    this.loadInsightProfile();
  },
  methods: {
    loadInsightProfile() {
      this.loading_persen = true;
      this.$store
        .dispatch(
          "instagramAccountOfficial/getInsightProfile",
          this.insightparams
        )
        .then(response => {
          const { data } = response;
          this.rows_insight = data;
          for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              const element = data[key];
              this.rows_percent[key] = this.hitungPersen(
                element["now"],
                element["then"]
              );
            }
          }
          let date = this.getDates(this.insightparams.percent_view)

          this.lineData = [
            { y: date['then'], a: data.follower['then'] },
            { y: date['now'], a: data.follower['now'] },
          ],
          this.loading_persen = false;
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    hitungPersen(jumlahBagian, jumlahTotal) {
      if (isNaN(jumlahBagian) || isNaN(jumlahTotal) || jumlahTotal === 0) {
        return 0;
      } else {
        let persen = ((jumlahBagian - jumlahTotal) / jumlahTotal * 100);
        return persen % 1 === 0 ? persen.toFixed(0) : persen.toFixed(2);
      }
    },
    renameLabel(value) {
      const labels = {
        follower: '<i class="fa fa-user-o"></i> Followers',
        profile_views: '<i class="fa fa-eye"></i> Profile Views',
        reach: '<i class="fa fa-snowflake-o"></i> Reach',
        impressions: '<i class="fa fa-star-o"></i> Impressions',
        phone_call_clicks: '<i class="fa fa-phone"></i> Phone Click',
        email_phone: '<i class="fa fa-envelope-o"></i> Email',
        website_clicks: '<i class="fa fa-mouse-pointer"></i> Website Click'
      };

      return labels[value] || "";
    },
    getDates(value) {
      const now = new Date();
      let timeAgo;
      if (value === "7daysago") {
        timeAgo = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
      } else if (value === "30daysago") {
        timeAgo = new Date(now.getTime() - 29 * 24 * 60 * 60 * 1000);
      } else if (value === "lastday") {
        timeAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000); 
      }
      const then = new Date(timeAgo.getTime() - (now.getTime() - timeAgo.getTime())); // Waktu 2 kali lipat dari value
      
      const nowFormatted = timeAgo.toISOString().slice(0,10); 
      const thenFormatted = then.toISOString().slice(0,10);
      
      return {
        now: nowFormatted,
        then: thenFormatted
      };
    }
  },
  mounted() {
    // $(document).ready(function() {
    //   lineChart();

    //   $(window).resize(function() {
    //     window.lineChart.redraw();
    //   });
    // });
    // function lineChart() {
    //   window.lineChart = Morris.Line({
    //     element: "line-chart",
    //     data: [
    //       { y: "2006", a: 50, b: 90 },
    //       { y: "2007", a: 75, b: 65 },
    //       { y: "2008", a: 50, b: 40 },
    //       { y: "2009", a: 75, b: 65 },
    //       { y: "2010", a: 50, b: 40 },
    //       { y: "2011", a: 75, b: 65 },
    //       { y: "2012", a: 100, b: 90 }
    //     ],
    //     xkey: "y",
    //     ykeys: ["a", "b"],
    //     labels: ["Total Sales", "Total Revenue"],
    //     lineColors: ["#ff9b44", "#fc6075"],
    //     lineWidth: "3px",
    //     resize: true,
    //     redraw: true
    //   });
    // }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "settings"
};
</script>



// WEBPACK FOOTER //
// src/views/instagram/instagramAnalytics/profile.vue